// Shared with linq-server (copied by its `npm run copy`), so it must only import from this folder.
//
// What part a system plays in keeping information: a system of record holds the authoritative copy, a business system
// does the work without being that copy, and a local tool (a spreadsheet, a document, email, a shared drive) is
// someone's own, with no controls around what is in it. The user says which on the system; until they do, LINQ reads it
// from the system's name, and says that it has
import { LinqsetNode, NODE_TYPE, SYSTEM_KIND } from "./linqset-base"

export const SYSTEM_KIND_LABELS: Record<SYSTEM_KIND, string> = {
    [SYSTEM_KIND.RECORD]: 'System of record',
    [SYSTEM_KIND.BUSINESS]: 'Business system',
    [SYSTEM_KIND.LOCAL]: 'Local tool',
}

// names that read as someone's own tool, device or channel: office documents and spreadsheets, pens, printers and
// scanners, phone, word of mouth, email and chat, files and shared drives
const LOCAL = /\b(microsoft office|ms office|office 365|m365|pens?|printers?|scanners?|cameras?|fax|phone|telephone|calls?|sms|text messages?|verbal|in person|face to face|meetings?|conversations?|excel|spreadsheets?|sheets?|xlsx?|csv|word|docs?|documents?|powerpoint|outlook|e-?mail|gmail|inbox|teams|slack|chat|onenote|notepad|access|onedrive|dropbox|google drive|share ?point|shared (drive|folder)|file ?share|network drive|desktop|personal|paper|notebook|whiteboard)\b/i
// names that read as where the authoritative copy is kept: finance, people, customer and asset systems, and databases
const RECORD = /\b(erp|crm|hris|hrms|hr system|payroll|ledger|general ledger|finance system|sap|oracle|netsuite|dynamics|salesforce|workday|xero|myob|sage|quickbooks|peoplesoft|servicenow|maximo|gis|arcgis|core banking|policy admin|epr|emr|ehr|student management|registry|master data|mdm|database|data warehouse|system of record)\b/i

// LINQ's read of a system from its name: an AI agent is a business system, as it works on records rather than keeping them
export const suggestSystemKind = (name: string | undefined, type?: NODE_TYPE): SYSTEM_KIND => {
    if (type === NODE_TYPE.AI_AGENT) return SYSTEM_KIND.BUSINESS
    const n = name || ''
    if (LOCAL.test(n)) return SYSTEM_KIND.LOCAL
    if (RECORD.test(n)) return SYSTEM_KIND.RECORD
    return SYSTEM_KIND.BUSINESS
}

// a system's kind, as the user said or as LINQ reads it, and which
export const systemKindOf = (node: Pick<LinqsetNode, 'name' | 'type'> & { properties?: { systemKind?: SYSTEM_KIND | null } }) => {
    const said = node.properties?.systemKind
    return said ? { kind: said, confirmed: true } : { kind: suggestSystemKind(node.name, node.type), confirmed: false }
}
